/* =============================================================================
   VIEWS / ADMIN / ARCHIVE-HELPERS — Geteilte Pure-Helpers (Session 68 REF-2)
   =============================================================================
   Heraushoisting aus archive.js. Sind:
     - _renderImmutabilityNote  Compliance-Hinweis-Banner (genutzt in orders/
                                 bons/zbons-Sub-Sections; siehe S59 Block F).
     - csvEscape                Sichere Excel-CSV-Quoting-Funktion.
     - downloadCsv              Browser-Download via Blob + Anchor.

   Vermeidet Circular Imports: archive.js → archive-orders.js → archive.js
   wäre nötig, wenn _renderImmutabilityNote in archive.js bliebe und von
   den Sub-Modulen aus importiert würde.
============================================================================ */

/**
 * S59 Block F — Compliance-Hinweis-Helper.
 * Wird in Sections gerendert, deren Daten gesetzlich unveränderlich sind.
 *
 * Begründungen pro Tabelle:
 *   - orders:    GoBD §147 AO (10 Jahre Aufbewahrung, Storno = cancelled-Status)
 *   - bons:      BSI TR-03153 + §146a AO (TSE-Signatur, append-only)
 *   - z_bons:    §146 AO (Tagesabschluss-Unveränderlichkeit)
 *
 * Reservierungen + Mails sind GoBD-irrelevant und dürfen soft-gelöscht werden.
 */
export function _renderImmutabilityNote(rechtsgrundlage) {
  return `
    <div style="margin-top:16px; padding:10px 14px; background:var(--bg-soft);
                border-left:3px solid var(--ink-muted); border-radius:4px;
                font-size:.82rem; color:var(--ink-soft);">
      🔒 <strong>Unveränderliche Daten</strong> — Diese Einträge können nicht gelöscht
      werden (${rechtsgrundlage}). Bei Bedarf nutze die Storno-Funktion in der
      jeweiligen Detail-Ansicht; der ursprüngliche Eintrag bleibt sichtbar.
    </div>
  `;
}

/** Sicheres CSV-Cell-Quoting für Excel-Excel-kompatibles Semikolon-CSV. */
export function csvEscape(s) {
  const str = String(s == null ? '' : s);
  return /[",;\n\r]/.test(str) ? '"' + str.replace(/"/g, '""') + '"' : str;
}

/** Browser-Download für CSV-Rows (Array<Array<string>>). UTF-8-BOM, CRLF. */
export function downloadCsv(rows, filename) {
  const csv = rows.map(row => row.map(csvEscape).join(';')).join('\r\n');
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
